import React from "react";
import { NavLink } from "react-router-dom";
const Showcase_news_cards_wrapper = () => {
  return (
    <section className="showcase-news-cards-wrapper">
      <h2
        className="section-main-heading wow fadeInUp animated"
        data-wow-duration="500ms"
        data-wow-delay="300ms"
      >
        Press &amp; News
      </h2>

      <div className="page-wrap row">
        <div
          className="col-4 item-wrapper wow fadeInUp animated"
          data-wow-duration="500ms"
          data-wow-delay="300ms"
        >
          <NavLink to={`/news/dreamfox`} className="item">
            <figure>
              <img
                src={`${process.env.REACT_APP_MEDIA_URL}/img/dreamfox_card.webp`}
                alt="Virtuos unveils Nexorama strategy to diversify into new areas"
              />
            </figure>
            <div className="content-wrapper">
              <span className="date">January 7, 2025
              </span>
              <h3 className="section-heading">
                Virtuos has new superpower: Dreamfox with AI driven Digital Marketing
              </h3>
            </div>
          </NavLink>
        </div>
        <div
          className="col-4 item-wrapper wow fadeInUp animated"
          data-wow-duration="500ms"
          data-wow-delay="300ms"
        >
          <NavLink to={`/news/cohering`} className="item">
            <figure>
              <img
                src={`${process.env.REACT_APP_MEDIA_URL}/img/cohering_news.jpg`}
                alt="Virtuos to unveil NOVV — NewWe Digital Transformation Practice"
              />
            </figure>
            <div className="content-wrapper">
              <span className="date">June 10, 2024</span>
              <h3 className="section-heading">
                Virtuos Unveils Cohering—A Revolutionary AI-Platforming Solution
                Mix
              </h3>
            </div>
          </NavLink>
        </div>
        <div
          className="col-4 item-wrapper wow fadeInUp animated"
          data-wow-duration="500ms"
          data-wow-delay="300ms"
        >
          <NavLink to={`/news/skillnow`} className="item">
            <figure>
              <img
                src={`${process.env.REACT_APP_MEDIA_URL}/img/skillnownewscard.webp
                `}
                alt="Virtuos Vivacis implements CRM and CLM Global Projects"
              />
            </figure>
            <div className="content-wrapper">
              <span className="date">May 10, 2024</span>
              <h3 className="section-heading">
                Virtuos Acquires SkillNow to Remodel as Agile Learning Platform
              </h3>
            </div>
          </NavLink>
        </div>

      </div>
    </section>
  );
};

export default Showcase_news_cards_wrapper;
